var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#CD263A",
    transform: "translate(5 5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M23.32 27.493l-.72-8.153-.18-4.34h5.16l-.18 4.34-.72 8.153h-3.36zM25 35c-1.74 0-3-1.349-3-3.05 0-1.7 1.26-3.05 3-3.05s3 1.35 3 3.05c0 1.701-1.26 3.05-3 3.05z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/warning-icon.3d7f4584ee503c6810bd3f194525f931.svg";
export { ForwardRef as ReactComponent };